module.exports = __webpack_public_path__ + "static/media/silabs.d53717d2.png";